/**
 * @license lucide v0.294.0 - ISC
 *
 * This source code is licensed under the ISC license.
 * See the LICENSE file in the root directory of this source tree.
 */

import defaultAttributes from '../defaultAttributes.js';

const Subtitles = [
  "svg",
  defaultAttributes,
  [
    ["path", { d: "M7 13h4" }],
    ["path", { d: "M15 13h2" }],
    ["path", { d: "M7 9h2" }],
    ["path", { d: "M13 9h4" }],
    ["path", { d: "M21 15a2 2 0 0 1-2 2H7l-4 4V5a2 2 0 0 1 2-2h14a2 2 0 0 1 2 2Z" }]
  ]
];

export { Subtitles as default };
//# sourceMappingURL=subtitles.js.map
